var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4513 3.65039L4.65134 12.4504C4.35068 12.7511 3.85201 12.7511 3.55134 12.4504C3.25068 12.1497 3.25068 11.6511 3.55134 11.3504L12.3513 2.55039C12.652 2.24972 13.1507 2.24972 13.4513 2.55039C13.752 2.85106 13.752 3.34972 13.4513 3.65039Z",
    fill: "#949DA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4513 12.4516C13.1507 12.7522 12.652 12.7522 12.3513 12.4516L3.55134 3.65156C3.25068 3.3509 3.25068 2.85223 3.55134 2.55156C3.85201 2.2509 4.35068 2.2509 4.65134 2.55156L13.4513 11.3516C13.752 11.6522 13.752 12.1509 13.4513 12.4516Z",
    fill: "#949DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEditIcon);
export default __webpack_public_path__ + "static/media/close-edit-icon.c2a3ce8ed0a865c3b83cd83e5260b3ae.svg";
export { ForwardRef as ReactComponent };